import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const PropostaEmpreendimentoParametroService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'proposta-empreendimento-parametro/excel/deletar', 'propostaEmpreendimentoParametroDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'proposta-empreendimento-parametro/excel', 'excelParametroEmpreendimento');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('proposta-empreendimento-parametro/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('proposta-empreendimento-parametro/eventGrid', {});
    }
}

export default PropostaEmpreendimentoParametroService;